export function ReportCard({ value, label }: { value: number, label: string }) {
    return (
        <div className="w-[335px] flex items-center gap-4 bg-white rounded-md">
            <div className="bg-primary3 rounded-full h-full w-2" />
            <div className="flex flex-col py-2">
                <span className="text-[35px] font-medium">{value}</span>
                <span className="text-[17px] font-medium">{label}</span>
            </div>
        </div>
    )
}